document.addEventListener('DOMContentLoaded', function () {
  const sections = Array.from(document.querySelectorAll('.shopify-section'))
  const navLinks = document.querySelectorAll('.sticky__nav-link')

  if (navLinks) {
    navLinks.forEach(link => link.addEventListener('click', function (e) {
      e.preventDefault()
      const target = document.querySelector(this.getAttribute('href'))
      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: 'smooth'
        })
      }
    }))
  }

  function onScroll () {
    if (!sections) return
    const passedSections = sections.filter(section => {
      const sectionTop = section.offsetTop
      return pageYOffset + window.innerHeight >= sectionTop + window.innerHeight - 200
    })
    if (navLinks) navLinks.forEach(link => link.classList.remove('active'))

    if (passedSections.length > 0) {
      const lastSection = passedSections[passedSections.length - 1]
      const activeLink = document.querySelector(`.sticky__nav-link[href="#${lastSection.id}"]`)
      if (activeLink) {
        activeLink.classList.add('active')
      }
    }
  }

  window.addEventListener('scroll', onScroll)
  onScroll() // Initialize on page load
})
